/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreClient from '@azure/core-client';
import * as Parameters from './models/parameters.js';
import * as Mappers from './models/mappers.js';
import {
    HostOptions,
    VsCodeEduClientOptionalParams,
    GetUserOptionalParams,
    GetUserResponse,
    DeleteUserOptionalParams,
    DeleteUserResponse,
    DownloadUserDataOptionalParams,
    DownloadUserDataResponse,
    DeleteUserDriveOptionalParams,
    DownloadUserDriveOptionalParams,
    DownloadUserDriveResponse,
    UploadUserDriveOptionalParams,
    ListUserProgressOptionalParams,
    ListUserProgressResponse,
    GetUserProgressOptionalParams,
    GetUserProgressResponse,
    CreateOrUpdateUserProgressOptionalParams,
    CreateOrUpdateUserProgressResponse,
    UpdateUserProgressOptionalParams,
    UpdateUserProgressResponse,
    DeleteUserProgressOptionalParams,
    DeleteUserProgressDriveOptionalParams,
    DownloadUserProgressDriveOptionalParams,
    DownloadUserProgressDriveResponse,
    UploadUserProgressDriveOptionalParams,
    ListUserProjectsOptionalParams,
    ListUserProjectsResponse,
    GetUserProjectOptionalParams,
    GetUserProjectResponse,
    CreateOrUpdateUserProjectOptionalParams,
    CreateOrUpdateUserProjectResponse,
    DeleteUserProjectOptionalParams,
    DeleteUserProjectResponse,
    PublishUserProjectOptionalParams,
    PublishUserProjectResponse,
    UnpublishUserProjectOptionalParams,
    UnpublishUserProjectResponse,
    CvsCallbackUserProjectOptionalParams,
    TakedownUserProjectOptionalParams,
    GetFileFromProjectOptionalParams,
    GetFileFromProjectResponse,
    RestoreUserProjectOptionalParams,
    CreateUserProjectSharedLinkOptionalParams,
    CreateUserProjectSharedLinkResponse,
    DeleteUserProjectSharedLinkOptionalParams,
    DownloadUserProjectDriveOptionalParams,
    DownloadUserProjectDriveResponse,
    UploadUserProjectDriveOptionalParams,
    GetImmersiveReaderConfigOptionalParams,
    GetImmersiveReaderConfigResponse,
    GetOperationOptionalParams,
    GetOperationResponse,
    ListUserCurriculaOptionalParams,
    ListUserCurriculaResponse,
    GetUserCurriculumOptionalParams,
    GetUserCurriculumResponse,
    CreateOrUpdateUserCurriculumOptionalParams,
    CreateOrUpdateUserCurriculumResponse,
    PatchUserCurriculumOptionalParams,
    DeleteUserCurriculumOptionalParams,
    DeleteUserCurriculumResponse,
    LinkUserCurriculumOptionalParams,
    LinkUserCurriculumResponse,
    PublishUserCurriculumOptionalParams,
    PublishUserCurriculumResponse,
    UnpublishUserCurriculumOptionalParams,
    UnpublishUserCurriculumResponse,
    PromptCopilotOptionalParams,
    PromptCopilotResponse,
    ListStandardGroupsOptionalParams,
    ListStandardGroupsResponse,
    GetStandardGroupOptionalParams,
    GetStandardGroupResponse,
    CreateOrUpdateStandardGroupOptionalParams,
    CreateOrUpdateStandardGroupResponse,
    UpdateStandardGroupOptionalParams,
    UpdateStandardGroupResponse,
    DeleteStandardGroupOptionalParams,
    ListStandardsOptionalParams,
    ListStandardsResponse,
    GetStandardOptionalParams,
    GetStandardResponse,
    CreateOrUpdateStandardOptionalParams,
    CreateOrUpdateStandardResponse,
    UpdateStandardOptionalParams,
    UpdateStandardResponse,
    DeleteStandardOptionalParams,
    ListLearningPathsOptionalParams,
    ListLearningPathsResponse,
    GetLearningPathOptionalParams,
    GetLearningPathResponse,
    CreateOrUpdateLearningPathOptionalParams,
    CreateOrUpdateLearningPathResponse,
    UpdateLearningPathOptionalParams,
    UpdateLearningPathResponse,
    DeleteLearningPathOptionalParams,
    ListCoursesOptionalParams,
    ListCoursesResponse,
    GetCourseOptionalParams,
    GetCourseResponse,
    CreateOrUpdateCourseOptionalParams,
    CreateOrUpdateCourseResponse,
    UpdateCourseOptionalParams,
    UpdateCourseResponse,
    DeleteCourseOptionalParams,
    DeleteCourseResponse,
    TakedownCourseOptionalParams,
    RestoreCourseOptionalParams,
    CvsCallbackCourseOptionalParams,
    DeleteCourseDriveOptionalParams,
    DownloadCourseDriveOptionalParams,
    DownloadCourseDriveResponse,
    UploadCourseDriveOptionalParams,
    ListCourseUnitsOptionalParams,
    ListCourseUnitsResponse,
    GetUnitOptionalParams,
    GetUnitResponse,
    CreateOrUpdateUnitOptionalParams,
    CreateOrUpdateUnitResponse,
    UpdateUnitOptionalParams,
    UpdateUnitResponse,
    DeleteUnitOptionalParams,
    DeletePackageDriveOptionalParams,
    DownloadPackageDriveOptionalParams,
    DownloadPackageDriveResponse,
    UploadPackageDriveOptionalParams,
    UploadContentOptionalParams,
    UploadContentBlobOptionalParams,
    GetConfigOptionalParams,
    GetConfigResponse,
    UpdateConfigOptionalParams,
    UpdateConfigResponse,
    PatchConfigOptionalParams,
    PatchConfigResponse,
    ReportAbuseOptionalParams,
    DeleteAppOptionalParams,
    DownloadAppFileOptionalParams,
    DownloadAppFileResponse,
    DownloadAppOptionalParams,
    DownloadAppResponse,
    UploadAppOptionalParams,
    TakedownAppOptionalParams,
    RestoreAppOptionalParams,
    ListProjectTemplatesOptionalParams,
    ListProjectTemplatesResponse,
    GetProjectTemplateOptionalParams,
    GetProjectTemplateResponse,
    CreateOrUpdateProjectTemplateOptionalParams,
    CreateOrUpdateProjectTemplateResponse,
    DeleteProjectTemplateOptionalParams,
    DeleteProjectTemplateDriveOptionalParams,
    DownloadProjectTemplateDriveOptionalParams,
    DownloadProjectTemplateDriveResponse,
    UploadProjectTemplateDriveOptionalParams,
    StartSessionOptions,
    StartSessionOptionalParams,
    StartSessionResponse,
    EndSessionOptionalParams,
    ExchangeSessionOptions,
    ExchangeSessionOptionalParams,
    ExchangeSessionResponse,
    NewSessionOptions,
    NewSessionOptionalParams,
    NewSessionResponse,
    NewOtacOptions,
    NewOtacOptionalParams,
    NewOtacResponse,
    ExchangeOtacOptions,
    ExchangeOtacOptionalParams,
    ExchangeOtacResponse,
    GetSharedLinkOptionalParams,
    GetSharedLinkResponse,
    DeleteSharedLinkOptionalParams,
    GithubInstallStartOptionalParams,
    GithubInstallStartResponse,
    GithubInstallExchangeOptions,
    GithubInstallExchangeOptionalParams,
    GithubUninstallOptionalParams,
} from './models/index.js';

export class VsCodeEduClient extends coreClient.ServiceClient {
    $host: HostOptions;

    /**
     * Initializes a new instance of the VsCodeEduClient class.
     * @param options The parameter options
     */
    constructor(options?: VsCodeEduClientOptionalParams) {
        // Initializing default values for options
        if (!options) {
            options = {};
        }
        const defaults: VsCodeEduClientOptionalParams = {
            requestContentType: 'application/json; charset=utf-8',
        };

        const packageDetails = `azsdk-js-vsCodeEduClient/1.0.0-beta.1`;
        const userAgentPrefix =
            options.userAgentOptions && options.userAgentOptions.userAgentPrefix
                ? `${options.userAgentOptions.userAgentPrefix} ${packageDetails}`
                : `${packageDetails}`;

        const optionsWithDefaults = {
            ...defaults,
            ...options,
            userAgentOptions: {
                userAgentPrefix,
            },
            endpoint: options.endpoint ?? options.baseUri ?? 'https://ppe.vscodeedu.com/api',
        };
        super(optionsWithDefaults);

        // Assigning values to Constant parameters
        this.$host = options.$host || 'https://ppe.vscodeedu.com/api';
    }

    /**
     * Returns a single user by ID.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    getUser(userId: string, options?: GetUserOptionalParams): Promise<GetUserResponse> {
        return this.sendOperationRequest({ userId, options }, getUserOperationSpec);
    }

    /**
     * Deletes a user and all associated learning progress data.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    deleteUser(userId: string, options?: DeleteUserOptionalParams): Promise<DeleteUserResponse> {
        return this.sendOperationRequest({ userId, options }, deleteUserOperationSpec);
    }

    /**
     * Returns all user's data packaged into a single ZIP archive.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    downloadUserData(userId: string, options?: DownloadUserDataOptionalParams): Promise<DownloadUserDataResponse> {
        return this.sendOperationRequest({ userId, options }, downloadUserDataOperationSpec);
    }

    /**
     * Deletes contents of the drive used to store personal user files ZIP format.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    deleteUserDrive(userId: string, options?: DeleteUserDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ userId, options }, deleteUserDriveOperationSpec);
    }

    /**
     * Returns contents of the drive used to store personal user files in ZIP format.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    downloadUserDrive(userId: string, options?: DownloadUserDriveOptionalParams): Promise<DownloadUserDriveResponse> {
        return this.sendOperationRequest({ userId, options }, downloadUserDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store personal user files in ZIP format.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    uploadUserDrive(userId: string, options?: UploadUserDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ userId, options }, uploadUserDriveOperationSpec);
    }

    /**
     * Returns a list of courses' progress for a specific user.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    listUserProgress(userId: string, options?: ListUserProgressOptionalParams): Promise<ListUserProgressResponse> {
        return this.sendOperationRequest({ userId, options }, listUserProgressOperationSpec);
    }

    /**
     * Returns course progress information for a specific user and course ID.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    getUserProgress(
        userId: string,
        courseId: string,
        options?: GetUserProgressOptionalParams
    ): Promise<GetUserProgressResponse> {
        return this.sendOperationRequest({ userId, courseId, options }, getUserProgressOperationSpec);
    }

    /**
     * Updates course progress information for a specific user and course ID.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    createOrUpdateUserProgress(
        userId: string,
        courseId: string,
        options?: CreateOrUpdateUserProgressOptionalParams
    ): Promise<CreateOrUpdateUserProgressResponse> {
        return this.sendOperationRequest({ userId, courseId, options }, createOrUpdateUserProgressOperationSpec);
    }

    /**
     * Updates progress for a subset of units/lessons in a course for a specific user and course ID.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    updateUserProgress(
        userId: string,
        courseId: string,
        options?: UpdateUserProgressOptionalParams
    ): Promise<UpdateUserProgressResponse> {
        return this.sendOperationRequest({ userId, courseId, options }, updateUserProgressOperationSpec);
    }

    /**
     * Deletes course progress information for a specific user and course ID.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    deleteUserProgress(userId: string, courseId: string, options?: DeleteUserProgressOptionalParams): Promise<void> {
        return this.sendOperationRequest({ userId, courseId, options }, deleteUserProgressOperationSpec);
    }

    /**
     * Deletes contents of the drive used to store user's course work in ZIP format.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    deleteUserProgressDrive(
        userId: string,
        courseId: string,
        options?: DeleteUserProgressDriveOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, courseId, options }, deleteUserProgressDriveOperationSpec);
    }

    /**
     * Returns contents of the drive used to store user's course work in ZIP format.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    downloadUserProgressDrive(
        userId: string,
        courseId: string,
        options?: DownloadUserProgressDriveOptionalParams
    ): Promise<DownloadUserProgressDriveResponse> {
        return this.sendOperationRequest({ userId, courseId, options }, downloadUserProgressDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store user's course work in ZIP format.
     * @param userId Unique identifier of the user.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    uploadUserProgressDrive(
        userId: string,
        courseId: string,
        options?: UploadUserProgressDriveOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, courseId, options }, uploadUserProgressDriveOperationSpec);
    }

    /**
     * Returns a list of all projects for the specified user.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    listUserProjects(userId: string, options?: ListUserProjectsOptionalParams): Promise<ListUserProjectsResponse> {
        return this.sendOperationRequest({ userId, options }, listUserProjectsOperationSpec);
    }

    /**
     * Returns project specified by the user and project ID.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    getUserProject(
        userId: string,
        projectId: string,
        options?: GetUserProjectOptionalParams
    ): Promise<GetUserProjectResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, getUserProjectOperationSpec);
    }

    /**
     * Updates project specified by the user and project ID.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    createOrUpdateUserProject(
        userId: string,
        projectId: string,
        options?: CreateOrUpdateUserProjectOptionalParams
    ): Promise<CreateOrUpdateUserProjectResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, createOrUpdateUserProjectOperationSpec);
    }

    /**
     * Deletes project specified by the user and project ID.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    deleteUserProject(
        userId: string,
        projectId: string,
        options?: DeleteUserProjectOptionalParams
    ): Promise<DeleteUserProjectResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, deleteUserProjectOperationSpec);
    }

    /**
     * Publishes the project files to a public web site or updates an existing web site with project's
     * content.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    publishUserProject(
        userId: string,
        projectId: string,
        options?: PublishUserProjectOptionalParams
    ): Promise<PublishUserProjectResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, publishUserProjectOperationSpec);
    }

    /**
     * Unpublishes a published user project from the web.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    unpublishUserProject(
        userId: string,
        projectId: string,
        options?: UnpublishUserProjectOptionalParams
    ): Promise<UnpublishUserProjectResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, unpublishUserProjectOperationSpec);
    }

    /**
     * Post CVS validation results for a user project
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    cvsCallbackUserProject(
        userId: string,
        projectId: string,
        options?: CvsCallbackUserProjectOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, projectId, options }, cvsCallbackUserProjectOperationSpec);
    }

    /**
     * Takes down a published user project from the web.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    takedownUserProject(userId: string, projectId: string, options?: TakedownUserProjectOptionalParams): Promise<void> {
        return this.sendOperationRequest({ userId, projectId, options }, takedownUserProjectOperationSpec);
    }

    /**
     * Retrieves a single file from the project.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param projectFilePath Path of a content file within a project.
     * @param options The options parameters.
     */
    getFileFromProject(
        userId: string,
        projectId: string,
        projectFilePath: string,
        options?: GetFileFromProjectOptionalParams
    ): Promise<GetFileFromProjectResponse> {
        return this.sendOperationRequest(
            { userId, projectId, projectFilePath, options },
            getFileFromProjectOperationSpec
        );
    }

    /**
     * Restores a published user project that has been taken down from the web.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    restoreUserProject(userId: string, projectId: string, options?: RestoreUserProjectOptionalParams): Promise<void> {
        return this.sendOperationRequest({ userId, projectId, options }, restoreUserProjectOperationSpec);
    }

    /**
     * Creates a new shared link for the project.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    createUserProjectSharedLink(
        userId: string,
        projectId: string,
        options?: CreateUserProjectSharedLinkOptionalParams
    ): Promise<CreateUserProjectSharedLinkResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, createUserProjectSharedLinkOperationSpec);
    }

    /**
     * Deletes the shared link for the project.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    deleteUserProjectSharedLink(
        userId: string,
        projectId: string,
        options?: DeleteUserProjectSharedLinkOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, projectId, options }, deleteUserProjectSharedLinkOperationSpec);
    }

    /**
     * Returns contents of the drive used to store user project's files in ZIP format.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    downloadUserProjectDrive(
        userId: string,
        projectId: string,
        options?: DownloadUserProjectDriveOptionalParams
    ): Promise<DownloadUserProjectDriveResponse> {
        return this.sendOperationRequest({ userId, projectId, options }, downloadUserProjectDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store user project's drive content in ZIP format.
     * @param userId Unique identifier of the user.
     * @param projectId User project identifier.
     * @param options The options parameters.
     */
    uploadUserProjectDrive(
        userId: string,
        projectId: string,
        options?: UploadUserProjectDriveOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, projectId, options }, uploadUserProjectDriveOperationSpec);
    }

    /**
     * Returns Immersive Reader client token information for the user.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    getImmersiveReaderConfig(
        userId: string,
        options?: GetImmersiveReaderConfigOptionalParams
    ): Promise<GetImmersiveReaderConfigResponse> {
        return this.sendOperationRequest({ userId, options }, getImmersiveReaderConfigOperationSpec);
    }

    /**
     * Returns the status of the operation.
     * @param userId Unique identifier of the user.
     * @param operationId Unique identifier of an operation.
     * @param options The options parameters.
     */
    getOperation(
        userId: string,
        operationId: string,
        options?: GetOperationOptionalParams
    ): Promise<GetOperationResponse> {
        return this.sendOperationRequest({ userId, operationId, options }, getOperationOperationSpec);
    }

    /**
     * Returns a list of all curricula assigned to the user.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    listUserCurricula(userId: string, options?: ListUserCurriculaOptionalParams): Promise<ListUserCurriculaResponse> {
        return this.sendOperationRequest({ userId, options }, listUserCurriculaOperationSpec);
    }

    /**
     * Returns user curriculum information.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    getUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: GetUserCurriculumOptionalParams
    ): Promise<GetUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, curriculumId, options }, getUserCurriculumOperationSpec);
    }

    /**
     * Updates user curriculum information.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    createOrUpdateUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: CreateOrUpdateUserCurriculumOptionalParams
    ): Promise<CreateOrUpdateUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, curriculumId, options }, createOrUpdateUserCurriculumOperationSpec);
    }

    /**
     * Updates a subset of properties of user curriculum information.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    patchUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: PatchUserCurriculumOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ userId, curriculumId, options }, patchUserCurriculumOperationSpec);
    }

    /**
     * Deletes user curriculum information.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    deleteUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: DeleteUserCurriculumOptionalParams
    ): Promise<DeleteUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, curriculumId, options }, deleteUserCurriculumOperationSpec);
    }

    /**
     * Links an existing GitHub curriculum repo to the user's account.
     * @param userId Unique identifier of the user.
     * @param repoName GitHub repository name.
     * @param options The options parameters.
     */
    linkUserCurriculum(
        userId: string,
        repoName: string,
        options?: LinkUserCurriculumOptionalParams
    ): Promise<LinkUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, repoName, options }, linkUserCurriculumOperationSpec);
    }

    /**
     * Publishes user curriculum to the course catalog.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    publishUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: PublishUserCurriculumOptionalParams
    ): Promise<PublishUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, curriculumId, options }, publishUserCurriculumOperationSpec);
    }

    /**
     * Unpublishes user curriculum from the course catalog.
     * @param userId Unique identifier of the user.
     * @param curriculumId Unique identifier of a curriculum.
     * @param options The options parameters.
     */
    unpublishUserCurriculum(
        userId: string,
        curriculumId: string,
        options?: UnpublishUserCurriculumOptionalParams
    ): Promise<UnpublishUserCurriculumResponse> {
        return this.sendOperationRequest({ userId, curriculumId, options }, unpublishUserCurriculumOperationSpec);
    }

    /**
     * Requests Copilot to assist with the user's content based on the provided context.
     * @param userId Unique identifier of the user.
     * @param options The options parameters.
     */
    promptCopilot(userId: string, options?: PromptCopilotOptionalParams): Promise<PromptCopilotResponse> {
        return this.sendOperationRequest({ userId, options }, promptCopilotOperationSpec);
    }

    /**
     * Returns a list of all available learning standard groups.
     * @param options The options parameters.
     */
    listStandardGroups(options?: ListStandardGroupsOptionalParams): Promise<ListStandardGroupsResponse> {
        return this.sendOperationRequest({ options }, listStandardGroupsOperationSpec);
    }

    /**
     * Returns a learning standard group with specified ID.
     * @param groupId Unique identifier of the learning standard group.
     * @param options The options parameters.
     */
    getStandardGroup(groupId: string, options?: GetStandardGroupOptionalParams): Promise<GetStandardGroupResponse> {
        return this.sendOperationRequest({ groupId, options }, getStandardGroupOperationSpec);
    }

    /**
     * Updates an existing or creates a new learning standard group.
     * @param groupId Unique identifier of the learning standard group.
     * @param options The options parameters.
     */
    createOrUpdateStandardGroup(
        groupId: string,
        options?: CreateOrUpdateStandardGroupOptionalParams
    ): Promise<CreateOrUpdateStandardGroupResponse> {
        return this.sendOperationRequest({ groupId, options }, createOrUpdateStandardGroupOperationSpec);
    }

    /**
     * Updates all or a subset of properties of an existing learning standard group.
     * @param groupId Unique identifier of the learning standard group.
     * @param options The options parameters.
     */
    updateStandardGroup(
        groupId: string,
        options?: UpdateStandardGroupOptionalParams
    ): Promise<UpdateStandardGroupResponse> {
        return this.sendOperationRequest({ groupId, options }, updateStandardGroupOperationSpec);
    }

    /**
     * Deletes an existing learning standard group.
     * @param groupId Unique identifier of the learning standard group.
     * @param options The options parameters.
     */
    deleteStandardGroup(groupId: string, options?: DeleteStandardGroupOptionalParams): Promise<void> {
        return this.sendOperationRequest({ groupId, options }, deleteStandardGroupOperationSpec);
    }

    /**
     * Returns a list of learning standards for a given standard group.
     * @param groupId Unique identifier of the learning standard group.
     * @param options The options parameters.
     */
    listStandards(groupId: string, options?: ListStandardsOptionalParams): Promise<ListStandardsResponse> {
        return this.sendOperationRequest({ groupId, options }, listStandardsOperationSpec);
    }

    /**
     * Returns a learning standard with specified ID within a given standard group.
     * @param groupId Unique identifier of the learning standard group.
     * @param standardId Identifier of the learning standard without containing group.
     * @param options The options parameters.
     */
    getStandard(
        groupId: string,
        standardId: string,
        options?: GetStandardOptionalParams
    ): Promise<GetStandardResponse> {
        return this.sendOperationRequest({ groupId, standardId, options }, getStandardOperationSpec);
    }

    /**
     * Updates an existing or creates a new learning standard.
     * @param groupId Unique identifier of the learning standard group.
     * @param standardId Identifier of the learning standard without containing group.
     * @param options The options parameters.
     */
    createOrUpdateStandard(
        groupId: string,
        standardId: string,
        options?: CreateOrUpdateStandardOptionalParams
    ): Promise<CreateOrUpdateStandardResponse> {
        return this.sendOperationRequest({ groupId, standardId, options }, createOrUpdateStandardOperationSpec);
    }

    /**
     * Updates all or a subset of properties of an existing learning standard.
     * @param groupId Unique identifier of the learning standard group.
     * @param standardId Identifier of the learning standard without containing group.
     * @param options The options parameters.
     */
    updateStandard(
        groupId: string,
        standardId: string,
        options?: UpdateStandardOptionalParams
    ): Promise<UpdateStandardResponse> {
        return this.sendOperationRequest({ groupId, standardId, options }, updateStandardOperationSpec);
    }

    /**
     * Deletes an existing learning standard.
     * @param groupId Unique identifier of the learning standard group.
     * @param standardId Identifier of the learning standard without containing group.
     * @param options The options parameters.
     */
    deleteStandard(groupId: string, standardId: string, options?: DeleteStandardOptionalParams): Promise<void> {
        return this.sendOperationRequest({ groupId, standardId, options }, deleteStandardOperationSpec);
    }

    /**
     * Returns a list of all available learning paths.
     * @param options The options parameters.
     */
    listLearningPaths(options?: ListLearningPathsOptionalParams): Promise<ListLearningPathsResponse> {
        return this.sendOperationRequest({ options }, listLearningPathsOperationSpec);
    }

    /**
     * Returns a learning path with specified ID.
     * @param pathId Unique identifier of the learning path.
     * @param options The options parameters.
     */
    getLearningPath(pathId: string, options?: GetLearningPathOptionalParams): Promise<GetLearningPathResponse> {
        return this.sendOperationRequest({ pathId, options }, getLearningPathOperationSpec);
    }

    /**
     * Updates an existing or creates a new learning path.
     * @param pathId Unique identifier of the learning path.
     * @param options The options parameters.
     */
    createOrUpdateLearningPath(
        pathId: string,
        options?: CreateOrUpdateLearningPathOptionalParams
    ): Promise<CreateOrUpdateLearningPathResponse> {
        return this.sendOperationRequest({ pathId, options }, createOrUpdateLearningPathOperationSpec);
    }

    /**
     * Updates all or a subset of properties of an existing learning path.
     * @param pathId Unique identifier of the learning path.
     * @param options The options parameters.
     */
    updateLearningPath(
        pathId: string,
        options?: UpdateLearningPathOptionalParams
    ): Promise<UpdateLearningPathResponse> {
        return this.sendOperationRequest({ pathId, options }, updateLearningPathOperationSpec);
    }

    /**
     * Deletes an existing learning path.
     * @param pathId Unique identifier of the learning path.
     * @param options The options parameters.
     */
    deleteLearningPath(pathId: string, options?: DeleteLearningPathOptionalParams): Promise<void> {
        return this.sendOperationRequest({ pathId, options }, deleteLearningPathOperationSpec);
    }

    /**
     * Returns a list of all available courses.
     * @param options The options parameters.
     */
    listCourses(options?: ListCoursesOptionalParams): Promise<ListCoursesResponse> {
        return this.sendOperationRequest({ options }, listCoursesOperationSpec);
    }

    /**
     * Returns course information by unique course identifier.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    getCourse(courseId: string, options?: GetCourseOptionalParams): Promise<GetCourseResponse> {
        return this.sendOperationRequest({ courseId, options }, getCourseOperationSpec);
    }

    /**
     * Updates an existing or creates a new learning course.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    createOrUpdateCourse(
        courseId: string,
        options?: CreateOrUpdateCourseOptionalParams
    ): Promise<CreateOrUpdateCourseResponse> {
        return this.sendOperationRequest({ courseId, options }, createOrUpdateCourseOperationSpec);
    }

    /**
     * Updates all or a subset of properties of an existing learning course.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    updateCourse(courseId: string, options?: UpdateCourseOptionalParams): Promise<UpdateCourseResponse> {
        return this.sendOperationRequest({ courseId, options }, updateCourseOperationSpec);
    }

    /**
     * Deletes an existing course and all its descendant units.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    deleteCourse(courseId: string, options?: DeleteCourseOptionalParams): Promise<DeleteCourseResponse> {
        return this.sendOperationRequest({ courseId, options }, deleteCourseOperationSpec);
    }

    /**
     * Takes down a published course from the web.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    takedownCourse(courseId: string, options?: TakedownCourseOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, options }, takedownCourseOperationSpec);
    }

    /**
     * Restore a published course that was taken down from the web.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    restoreCourse(courseId: string, options?: RestoreCourseOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, options }, restoreCourseOperationSpec);
    }

    /**
     * Post CVS validation results for a course
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    cvsCallbackCourse(courseId: string, options?: CvsCallbackCourseOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, options }, cvsCallbackCourseOperationSpec);
    }

    /**
     * Deletes contents of the drive used to store course files in ZIP format.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    deleteCourseDrive(courseId: string, options?: DeleteCourseDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, options }, deleteCourseDriveOperationSpec);
    }

    /**
     * Returns contents of the drive used to store course files in ZIP format.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    downloadCourseDrive(
        courseId: string,
        options?: DownloadCourseDriveOptionalParams
    ): Promise<DownloadCourseDriveResponse> {
        return this.sendOperationRequest({ courseId, options }, downloadCourseDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store course files in ZIP format.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    uploadCourseDrive(courseId: string, options?: UploadCourseDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, options }, uploadCourseDriveOperationSpec);
    }

    /**
     * Returns all units for a specific course.
     * @param courseId Unique identifier of the course.
     * @param options The options parameters.
     */
    listCourseUnits(courseId: string, options?: ListCourseUnitsOptionalParams): Promise<ListCourseUnitsResponse> {
        return this.sendOperationRequest({ courseId, options }, listCourseUnitsOperationSpec);
    }

    /**
     * Returns a course unit with specified ID within specified course.
     * @param courseId Unique identifier of the course.
     * @param unitId Identifier of a course unit, unique within the course.
     * @param options The options parameters.
     */
    getUnit(courseId: string, unitId: string, options?: GetUnitOptionalParams): Promise<GetUnitResponse> {
        return this.sendOperationRequest({ courseId, unitId, options }, getUnitOperationSpec);
    }

    /**
     * Updates an existing or creates a new course unit.
     * @param courseId Unique identifier of the course.
     * @param unitId Identifier of a course unit, unique within the course.
     * @param options The options parameters.
     */
    createOrUpdateUnit(
        courseId: string,
        unitId: string,
        options?: CreateOrUpdateUnitOptionalParams
    ): Promise<CreateOrUpdateUnitResponse> {
        return this.sendOperationRequest({ courseId, unitId, options }, createOrUpdateUnitOperationSpec);
    }

    /**
     * Updates all or a subset of properties of an existing course unit.
     * @param courseId Unique identifier of the course.
     * @param unitId Identifier of a course unit, unique within the course.
     * @param options The options parameters.
     */
    updateUnit(courseId: string, unitId: string, options?: UpdateUnitOptionalParams): Promise<UpdateUnitResponse> {
        return this.sendOperationRequest({ courseId, unitId, options }, updateUnitOperationSpec);
    }

    /**
     * Deletes an existing course unit.
     * @param courseId Unique identifier of the course.
     * @param unitId Identifier of a course unit, unique within the course.
     * @param options The options parameters.
     */
    deleteUnit(courseId: string, unitId: string, options?: DeleteUnitOptionalParams): Promise<void> {
        return this.sendOperationRequest({ courseId, unitId, options }, deleteUnitOperationSpec);
    }

    /**
     * Deletes contents of the drive used to store a package ZIP format.
     * @param packageId Unique identifier of the package
     * @param options The options parameters.
     */
    deletePackageDrive(packageId: string, options?: DeletePackageDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ packageId, options }, deletePackageDriveOperationSpec);
    }

    /**
     * Returns contents of the drive used to a package in ZIP format.
     * @param packageId Unique identifier of the package
     * @param options The options parameters.
     */
    downloadPackageDrive(
        packageId: string,
        options?: DownloadPackageDriveOptionalParams
    ): Promise<DownloadPackageDriveResponse> {
        return this.sendOperationRequest({ packageId, options }, downloadPackageDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store a package in ZIP format.
     * @param packageId Unique identifier of the package
     * @param options The options parameters.
     */
    uploadPackageDrive(packageId: string, options?: UploadPackageDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ packageId, options }, uploadPackageDriveOperationSpec);
    }

    /**
     * Creates or updates a static blob storage container to match the ZIP provided.
     * @param containerName Name of blob storage container.
     * @param options The options parameters.
     */
    uploadContent(containerName: string, options?: UploadContentOptionalParams): Promise<void> {
        return this.sendOperationRequest({ containerName, options }, uploadContentOperationSpec);
    }

    /**
     * Creates or updates a static content blob to match the ZIP provided.
     * @param containerName Name of blob storage container.
     * @param blobName Name of blob storage blob inside container.
     * @param options The options parameters.
     */
    uploadContentBlob(
        containerName: string,
        blobName: string,
        options?: UploadContentBlobOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ containerName, blobName, options }, uploadContentBlobOperationSpec);
    }

    /**
     * Returns current configuration of the service.
     * @param options The options parameters.
     */
    getConfig(options?: GetConfigOptionalParams): Promise<GetConfigResponse> {
        return this.sendOperationRequest({ options }, getConfigOperationSpec);
    }

    /**
     * Updates configuration of the service.
     * @param options The options parameters.
     */
    updateConfig(options?: UpdateConfigOptionalParams): Promise<UpdateConfigResponse> {
        return this.sendOperationRequest({ options }, updateConfigOperationSpec);
    }

    /**
     * patches configuration of the service.
     * @param options The options parameters.
     */
    patchConfig(options?: PatchConfigOptionalParams): Promise<PatchConfigResponse> {
        return this.sendOperationRequest({ options }, patchConfigOperationSpec);
    }

    /**
     * Report user generated content for policy violations.
     * @param options The options parameters.
     */
    reportAbuse(options?: ReportAbuseOptionalParams): Promise<void> {
        return this.sendOperationRequest({ options }, reportAbuseOperationSpec);
    }

    /**
     * Deletes the app and all its content.
     * @param appName Name of a hosted web app.
     * @param options The options parameters.
     */
    deleteApp(appName: string, options?: DeleteAppOptionalParams): Promise<void> {
        return this.sendOperationRequest({ appName, options }, deleteAppOperationSpec);
    }

    /**
     * Returns content of the requested app's content file.
     * @param appName Name of a hosted web app.
     * @param appFilePath Path of a content file within an app.
     * @param options The options parameters.
     */
    downloadAppFile(
        appName: string,
        appFilePath: string,
        options?: DownloadAppFileOptionalParams
    ): Promise<DownloadAppFileResponse> {
        return this.sendOperationRequest({ appName, appFilePath, options }, downloadAppFileOperationSpec);
    }

    /**
     * Returns content of the app in ZIP format.
     * @param appName Name of a hosted web app.
     * @param options The options parameters.
     */
    downloadApp(appName: string, options?: DownloadAppOptionalParams): Promise<DownloadAppResponse> {
        return this.sendOperationRequest({ appName, options }, downloadAppOperationSpec);
    }

    /**
     * Updates contents of the app to match that from specified ZIP archive.
     * @param appName Name of a hosted web app.
     * @param options The options parameters.
     */
    uploadApp(appName: string, options?: UploadAppOptionalParams): Promise<void> {
        return this.sendOperationRequest({ appName, options }, uploadAppOperationSpec);
    }

    /**
     * Takes down a published app from the web
     * @param appName Name of a hosted web app.
     * @param options The options parameters.
     */
    takedownApp(appName: string, options?: TakedownAppOptionalParams): Promise<void> {
        return this.sendOperationRequest({ appName, options }, takedownAppOperationSpec);
    }

    /**
     * Restore a taken down app from the web
     * @param appName Name of a hosted web app.
     * @param options The options parameters.
     */
    restoreApp(appName: string, options?: RestoreAppOptionalParams): Promise<void> {
        return this.sendOperationRequest({ appName, options }, restoreAppOperationSpec);
    }

    /**
     * Returns a list of available project templates.
     * @param options The options parameters.
     */
    listProjectTemplates(options?: ListProjectTemplatesOptionalParams): Promise<ListProjectTemplatesResponse> {
        return this.sendOperationRequest({ options }, listProjectTemplatesOperationSpec);
    }

    /**
     * Returns project template with specified ID.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    getProjectTemplate(
        templateId: string,
        options?: GetProjectTemplateOptionalParams
    ): Promise<GetProjectTemplateResponse> {
        return this.sendOperationRequest({ templateId, options }, getProjectTemplateOperationSpec);
    }

    /**
     * Creates new or updates existing project template with specified ID.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    createOrUpdateProjectTemplate(
        templateId: string,
        options?: CreateOrUpdateProjectTemplateOptionalParams
    ): Promise<CreateOrUpdateProjectTemplateResponse> {
        return this.sendOperationRequest({ templateId, options }, createOrUpdateProjectTemplateOperationSpec);
    }

    /**
     * Deletes project template with specified ID.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    deleteProjectTemplate(templateId: string, options?: DeleteProjectTemplateOptionalParams): Promise<void> {
        return this.sendOperationRequest({ templateId, options }, deleteProjectTemplateOperationSpec);
    }

    /**
     * Deletes contents of the drive used to store project template files ZIP format.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    deleteProjectTemplateDrive(templateId: string, options?: DeleteProjectTemplateDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ templateId, options }, deleteProjectTemplateDriveOperationSpec);
    }

    /**
     * Returns contents of the drive used to store project template files in ZIP format.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    downloadProjectTemplateDrive(
        templateId: string,
        options?: DownloadProjectTemplateDriveOptionalParams
    ): Promise<DownloadProjectTemplateDriveResponse> {
        return this.sendOperationRequest({ templateId, options }, downloadProjectTemplateDriveOperationSpec);
    }

    /**
     * Updates contents of the drive used to store project template files in ZIP format.
     * @param templateId Project template identifier.
     * @param options The options parameters.
     */
    uploadProjectTemplateDrive(templateId: string, options?: UploadProjectTemplateDriveOptionalParams): Promise<void> {
        return this.sendOperationRequest({ templateId, options }, uploadProjectTemplateDriveOperationSpec);
    }

    /**
     * Starts a new authenticated session creation for a specified provider.
     * @param startSessionOptions Parameter group
     * @param options The options parameters.
     */
    startSession(
        startSessionOptions: StartSessionOptions,
        options?: StartSessionOptionalParams
    ): Promise<StartSessionResponse> {
        return this.sendOperationRequest({ startSessionOptions, options }, startSessionOperationSpec);
    }

    /**
     * Ends an authenticated session.
     * @param options The options parameters.
     */
    endSession(options?: EndSessionOptionalParams): Promise<void> {
        return this.sendOperationRequest({ options }, endSessionOperationSpec);
    }

    /**
     * Exchanges authentication code for access token during session creation.
     * @param exchangeSessionOptions Parameter group
     * @param options The options parameters.
     */
    exchangeSession(
        exchangeSessionOptions: ExchangeSessionOptions,
        options?: ExchangeSessionOptionalParams
    ): Promise<ExchangeSessionResponse> {
        return this.sendOperationRequest({ exchangeSessionOptions, options }, exchangeSessionOperationSpec);
    }

    /**
     * Creates a new authenticated session for a given access code.
     * @param newSessionOptions Parameter group
     * @param options The options parameters.
     */
    newSession(newSessionOptions: NewSessionOptions, options?: NewSessionOptionalParams): Promise<NewSessionResponse> {
        return this.sendOperationRequest({ newSessionOptions, options }, newSessionOperationSpec);
    }

    /**
     * Creates a new OTAC for an active session.
     * @param newOtacOptions Parameter group
     * @param options The options parameters.
     */
    newOtac(newOtacOptions: NewOtacOptions, options?: NewOtacOptionalParams): Promise<NewOtacResponse> {
        return this.sendOperationRequest({ newOtacOptions, options }, newOtacOperationSpec);
    }

    /**
     * Exchanges OTAC for a session token of an actiive session.
     * @param exchangeOtacOptions Parameter group
     * @param options The options parameters.
     */
    exchangeOtac(
        exchangeOtacOptions: ExchangeOtacOptions,
        options?: ExchangeOtacOptionalParams
    ): Promise<ExchangeOtacResponse> {
        return this.sendOperationRequest({ exchangeOtacOptions, options }, exchangeOtacOperationSpec);
    }

    /**
     * Returns details information about shared link with specified ID.
     * @param linkId Unique identifier of the shared link.
     * @param options The options parameters.
     */
    getSharedLink(linkId: string, options?: GetSharedLinkOptionalParams): Promise<GetSharedLinkResponse> {
        return this.sendOperationRequest({ linkId, options }, getSharedLinkOperationSpec);
    }

    /**
     * Deletes shared link with specified ID.
     * @param linkId Unique identifier of the shared link.
     * @param options The options parameters.
     */
    deleteSharedLink(linkId: string, options?: DeleteSharedLinkOptionalParams): Promise<void> {
        return this.sendOperationRequest({ linkId, options }, deleteSharedLinkOperationSpec);
    }

    /**
     * Returns the github installation link for the current user.
     * @param redirectUrl Redirect URL for authentication
     * @param options The options parameters.
     */
    githubInstallStart(
        redirectUrl: string,
        options?: GithubInstallStartOptionalParams
    ): Promise<GithubInstallStartResponse> {
        return this.sendOperationRequest({ redirectUrl, options }, githubInstallStartOperationSpec);
    }

    /**
     * Exchange the installation code for an access token.
     * @param githubInstallExchangeOptions Parameter group
     * @param options The options parameters.
     */
    githubInstallExchange(
        githubInstallExchangeOptions: GithubInstallExchangeOptions,
        options?: GithubInstallExchangeOptionalParams
    ): Promise<void> {
        return this.sendOperationRequest({ githubInstallExchangeOptions, options }, githubInstallExchangeOperationSpec);
    }

    /**
     * Removes linking of Github account for the current user.
     * @param options The options parameters.
     */
    githubUninstall(options?: GithubUninstallOptionalParams): Promise<void> {
        return this.sendOperationRequest({ options }, githubUninstallOperationSpec);
    }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getUserOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.User,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept],
    serializer,
};
const deleteUserOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}',
    httpMethod: 'DELETE',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientDeleteUserHeaders,
        },
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    serializer,
};
const downloadUserDataOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/data/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const deleteUserDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/drive',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    serializer,
};
const downloadUserDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadUserDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const listUserProgressOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'UserProgress' } },
                },
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getUserProgressOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.UserProgress,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateUserProgressOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.UserProgress,
        },
        201: {
            bodyMapper: Mappers.UserProgress,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateUserProgressOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.UserProgress,
        },
        201: {
            bodyMapper: Mappers.UserProgress,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteUserProgressOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    serializer,
};
const deleteUserProgressDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}/drive',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    serializer,
};
const downloadUserProgressDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadUserProgressDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/courses/{courseId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.courseId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const listUserProjectsOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'Project' } },
                },
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Project,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.Project,
        },
        201: {
            bodyMapper: Mappers.Project,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body1,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}',
    httpMethod: 'DELETE',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientDeleteUserProjectHeaders,
        },
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const publishUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:publish',
    httpMethod: 'POST',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientPublishUserProjectHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const unpublishUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:unpublish',
    httpMethod: 'POST',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientUnpublishUserProjectHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const cvsCallbackUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:cvscallback',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    requestBody: Parameters.body2,
    queryParameters: [Parameters.cvsResponseKey],
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const takedownUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:takedown',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    queryParameters: [Parameters.cvsResponseKey],
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const getFileFromProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:file',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'Stream' } },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    queryParameters: [Parameters.cvsResponseKey, Parameters.projectFilePath],
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.accept2],
    serializer,
};
const restoreUserProjectOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}:restore',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const createUserProjectSharedLinkOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}/sharedLink',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: Mappers.Project,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.accept],
    serializer,
};
const deleteUserProjectSharedLinkOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}/sharedLink',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    serializer,
};
const downloadUserProjectDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadUserProjectDriveOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/projects/{projectId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.projectId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const getImmersiveReaderConfigOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/irConfig',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.ImmersiveReaderConfig,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getOperationOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/operations/{operationId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Operation,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.operationId],
    headerParameters: [Parameters.accept],
    serializer,
};
const listUserCurriculaOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'Curriculum' } },
                },
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Curriculum,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}',
    httpMethod: 'PUT',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientCreateOrUpdateUserCurriculumHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body3,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    headerParameters: [Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const patchUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}',
    httpMethod: 'PATCH',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body4,
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    headerParameters: [Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}',
    httpMethod: 'DELETE',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientDeleteUserCurriculumHeaders,
        },
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    serializer,
};
const linkUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula:link',
    httpMethod: 'POST',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientLinkUserCurriculumHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    queryParameters: [Parameters.repoName, Parameters.platform],
    urlParameters: [Parameters.$host, Parameters.userId],
    serializer,
};
const publishUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}:publish',
    httpMethod: 'POST',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientPublishUserCurriculumHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    serializer,
};
const unpublishUserCurriculumOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/curricula/{curriculumId}:unpublish',
    httpMethod: 'POST',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientUnpublishUserCurriculumHeaders,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.userId, Parameters.curriculumId],
    serializer,
};
const promptCopilotOperationSpec: coreClient.OperationSpec = {
    path: '/users/{userId}/copilot:prompt',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: Mappers.PromptResponse,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body5,
    urlParameters: [Parameters.$host, Parameters.userId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const listStandardGroupsOperationSpec: coreClient.OperationSpec = {
    path: '/standards',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'StandardGroup' } },
                },
            },
        },
    },
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer,
};
const getStandardGroupOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.StandardGroup,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.groupId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateStandardGroupOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.StandardGroup,
        },
        201: {
            bodyMapper: Mappers.StandardGroup,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body6,
    urlParameters: [Parameters.$host, Parameters.groupId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateStandardGroupOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.StandardGroup,
        },
        201: {
            bodyMapper: Mappers.StandardGroup,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body6,
    urlParameters: [Parameters.$host, Parameters.groupId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteStandardGroupOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.groupId],
    serializer,
};
const listStandardsOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}/items',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'Standard' } },
                },
            },
        },
    },
    urlParameters: [Parameters.$host, Parameters.groupId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getStandardOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}/items/{standardId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Standard,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.groupId, Parameters.standardId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateStandardOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}/items/{standardId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.Standard,
        },
        201: {
            bodyMapper: Mappers.Standard,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body7,
    urlParameters: [Parameters.$host, Parameters.groupId, Parameters.standardId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateStandardOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}/items/{standardId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.Standard,
        },
        201: {
            bodyMapper: Mappers.Standard,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body7,
    urlParameters: [Parameters.$host, Parameters.groupId, Parameters.standardId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteStandardOperationSpec: coreClient.OperationSpec = {
    path: '/standards/{groupId}/items/{standardId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.groupId, Parameters.standardId],
    serializer,
};
const listLearningPathsOperationSpec: coreClient.OperationSpec = {
    path: '/learningPaths',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'LearningPath' } },
                },
            },
        },
    },
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer,
};
const getLearningPathOperationSpec: coreClient.OperationSpec = {
    path: '/learningPaths/{pathId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.LearningPath,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.pathId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateLearningPathOperationSpec: coreClient.OperationSpec = {
    path: '/learningPaths/{pathId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.LearningPath,
        },
        201: {
            bodyMapper: Mappers.LearningPath,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body8,
    urlParameters: [Parameters.$host, Parameters.pathId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateLearningPathOperationSpec: coreClient.OperationSpec = {
    path: '/learningPaths/{pathId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.LearningPath,
        },
        201: {
            bodyMapper: Mappers.LearningPath,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body8,
    urlParameters: [Parameters.$host, Parameters.pathId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteLearningPathOperationSpec: coreClient.OperationSpec = {
    path: '/learningPaths/{pathId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.pathId],
    serializer,
};
const listCoursesOperationSpec: coreClient.OperationSpec = {
    path: '/courses',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'Course' } },
                },
            },
        },
    },
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer,
};
const getCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Course,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.Course,
        },
        201: {
            bodyMapper: Mappers.Course,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body9,
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.Course,
        },
        201: {
            bodyMapper: Mappers.Course,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body9,
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}',
    httpMethod: 'DELETE',
    responses: {
        202: {
            headersMapper: Mappers.VsCodeEduClientDeleteCourseHeaders,
        },
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId],
    serializer,
};
const takedownCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}:takedown',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    queryParameters: [Parameters.cvsResponseKey],
    urlParameters: [Parameters.$host, Parameters.courseId],
    serializer,
};
const restoreCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}:restore',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    queryParameters: [Parameters.cvsResponseKey],
    urlParameters: [Parameters.$host, Parameters.courseId],
    serializer,
};
const cvsCallbackCourseOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}:cvscallback',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    requestBody: Parameters.body2,
    queryParameters: [Parameters.cvsResponseKey],
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteCourseDriveOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/drive',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId],
    serializer,
};
const downloadCourseDriveOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadCourseDriveOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const listCourseUnitsOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/units',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: { type: { name: 'Composite', className: 'Unit' } },
                },
            },
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId],
    headerParameters: [Parameters.accept],
    serializer,
};
const getUnitOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/units/{unitId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.Unit,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId, Parameters.unitId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateUnitOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/units/{unitId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.Unit,
        },
        201: {
            bodyMapper: Mappers.Unit,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body10,
    urlParameters: [Parameters.$host, Parameters.courseId, Parameters.unitId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const updateUnitOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/units/{unitId}',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: Mappers.Unit,
        },
        201: {
            bodyMapper: Mappers.Unit,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body10,
    urlParameters: [Parameters.$host, Parameters.courseId, Parameters.unitId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteUnitOperationSpec: coreClient.OperationSpec = {
    path: '/courses/{courseId}/units/{unitId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.courseId, Parameters.unitId],
    serializer,
};
const deletePackageDriveOperationSpec: coreClient.OperationSpec = {
    path: '/packages/{packageId}/drive',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.packageId],
    serializer,
};
const downloadPackageDriveOperationSpec: coreClient.OperationSpec = {
    path: '/packages/{packageId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.packageId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadPackageDriveOperationSpec: coreClient.OperationSpec = {
    path: '/packages/{packageId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.packageId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const uploadContentOperationSpec: coreClient.OperationSpec = {
    path: '/content/{containerName}/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.containerName],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const uploadContentBlobOperationSpec: coreClient.OperationSpec = {
    path: '/content/{containerName}/{blobName}/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.containerName, Parameters.blobName],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const getConfigOperationSpec: coreClient.OperationSpec = {
    path: '/config',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Dictionary', value: { type: { name: 'String' } } },
            },
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer,
};
const updateConfigOperationSpec: coreClient.OperationSpec = {
    path: '/config',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Dictionary', value: { type: { name: 'String' } } },
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body11,
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const patchConfigOperationSpec: coreClient.OperationSpec = {
    path: '/config',
    httpMethod: 'PATCH',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Dictionary', value: { type: { name: 'String' } } },
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body11,
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const reportAbuseOperationSpec: coreClient.OperationSpec = {
    path: '/reportAbuse',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    requestBody: Parameters.body12,
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteAppOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.appName],
    serializer,
};
const downloadAppFileOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}{appFilePath}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: { type: { name: 'Stream' } },
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.appName, Parameters.appFilePath],
    headerParameters: [Parameters.accept2],
    serializer,
};
const downloadAppOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.appName],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadAppOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.appName],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const takedownAppOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}/takedown',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.appName],
    serializer,
};
const restoreAppOperationSpec: coreClient.OperationSpec = {
    path: '/apps/{appName}/restore',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.appName],
    serializer,
};
const listProjectTemplatesOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: {
                    name: 'Sequence',
                    element: {
                        type: { name: 'Composite', className: 'ProjectTemplate' },
                    },
                },
            },
        },
    },
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept],
    serializer,
};
const getProjectTemplateOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.ProjectTemplate,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.templateId],
    headerParameters: [Parameters.accept],
    serializer,
};
const createOrUpdateProjectTemplateOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}',
    httpMethod: 'PUT',
    responses: {
        200: {
            bodyMapper: Mappers.ProjectTemplate,
        },
        201: {
            bodyMapper: Mappers.ProjectTemplate,
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.body13,
    urlParameters: [Parameters.$host, Parameters.templateId],
    headerParameters: [Parameters.accept, Parameters.contentType1],
    mediaType: 'json',
    serializer,
};
const deleteProjectTemplateOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.templateId],
    serializer,
};
const deleteProjectTemplateDriveOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}/drive',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.templateId],
    serializer,
};
const downloadProjectTemplateDriveOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}/drive/$value',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: {
                type: { name: 'Stream' },
                serializedName: 'parsedResponse',
            },
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.templateId],
    headerParameters: [Parameters.accept1],
    serializer,
};
const uploadProjectTemplateDriveOperationSpec: coreClient.OperationSpec = {
    path: '/projectTemplates/{templateId}/drive/$value',
    httpMethod: 'PUT',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    requestBody: Parameters.data,
    urlParameters: [Parameters.$host, Parameters.templateId],
    headerParameters: [Parameters.contentType],
    mediaType: 'binary',
    serializer,
};
const startSessionOperationSpec: coreClient.OperationSpec = {
    path: '/auth/session:start',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    queryParameters: [Parameters.authProvider, Parameters.redirectUrl, Parameters.longTerm],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const endSessionOperationSpec: coreClient.OperationSpec = {
    path: '/auth/session:end',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host],
    serializer,
};
const exchangeSessionOperationSpec: coreClient.OperationSpec = {
    path: '/auth/session:exchange',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
    },
    queryParameters: [Parameters.state, Parameters.accessCode],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const newSessionOperationSpec: coreClient.OperationSpec = {
    path: '/auth/session:new',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
    },
    queryParameters: [Parameters.authProvider1, Parameters.longTerm1, Parameters.accessCode1, Parameters.redirectUrl1],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const newOtacOperationSpec: coreClient.OperationSpec = {
    path: '/auth/otac:create',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
    },
    queryParameters: [Parameters.codeChallenge, Parameters.longTerm2],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const exchangeOtacOperationSpec: coreClient.OperationSpec = {
    path: '/auth/otac:exchange',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
    },
    queryParameters: [Parameters.otac, Parameters.codeVerifier],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const getSharedLinkOperationSpec: coreClient.OperationSpec = {
    path: '/sharedLinks/{linkId}',
    httpMethod: 'GET',
    responses: {
        200: {
            bodyMapper: Mappers.SharedLink,
        },
        400: {
            isError: true,
        },
        404: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.linkId],
    headerParameters: [Parameters.accept],
    serializer,
};
const deleteSharedLinkOperationSpec: coreClient.OperationSpec = {
    path: '/sharedLinks/{linkId}',
    httpMethod: 'DELETE',
    responses: {
        204: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
        403: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host, Parameters.linkId],
    serializer,
};
const githubInstallStartOperationSpec: coreClient.OperationSpec = {
    path: '/github/install:start',
    httpMethod: 'POST',
    responses: {
        200: {
            bodyMapper: { type: { name: 'String' } },
        },
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    queryParameters: [Parameters.redirectUrl2],
    urlParameters: [Parameters.$host],
    headerParameters: [Parameters.accept3],
    serializer,
};
const githubInstallExchangeOperationSpec: coreClient.OperationSpec = {
    path: '/github/install:exchange',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    queryParameters: [Parameters.accessCode2, Parameters.state1],
    urlParameters: [Parameters.$host],
    serializer,
};
const githubUninstallOperationSpec: coreClient.OperationSpec = {
    path: '/github/uninstall',
    httpMethod: 'POST',
    responses: {
        200: {},
        400: {
            isError: true,
        },
        401: {
            isError: true,
        },
    },
    urlParameters: [Parameters.$host],
    serializer,
};
